import { observer } from 'mobx-react'
import React, { useState } from 'react'
import RenderOnQueries from '../RenderOnQueries'
import SelectionList from './SelectionList'
import TimesheetAppStore from './TimesheetAppStore'
import { canEnterTimeAgainstPhase } from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import { trpc } from '../../system/trpc'
import { processTRPCData } from '../../Queries/fetchData'

export default observer(() => {
    return (
        <RenderOnQueries
            queryIds={[
                {
                    id: `phases-${TimesheetAppStore.selectedProject.id}`,
                    queryFn: async () => {
                        const requestData =
                            await trpc.legacy.getProjectPhases.query({
                                projectId: TimesheetAppStore.selectedProject.id,
                            })
                        return processTRPCData(
                            requestData,
                            `phases-${TimesheetAppStore.selectedProject.id}`
                        )
                    },
                },
            ]}
        >
            <SelectionList
                title={'Phase'}
                label={'title'}
                sortBy={'startDate'}
                items={
                    TimesheetAppStore.selectedProject.phases.filter((p) =>
                        canEnterTimeAgainstPhase(SessionStore.user, p)
                    ) || []
                }
                backRoute={'selectProject'}
                onChange={(phase) => {
                    TimesheetAppStore.selectPhase(phase)
                    TimesheetAppStore.setRoute('selectTask')
                }}
            />
        </RenderOnQueries>
    )
})
